import { useState } from "react";
import { ArrowRight } from "lucide-react";
import { toast } from "sonner";
import { errText, joinWaitlist } from "@/lib/api";

export const WaitlistForm = ({ drop, testid = `waitlist-${drop.slug}`, dark }) => {
  const [email, setEmail] = useState("");
  const [crew, setCrew] = useState(false);
  const [done, setDone] = useState(null);
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { const r = await joinWaitlist(drop.slug, { email, newsletter: crew }); setDone(r.message); toast.success(r.message); } catch (err) { toast.error(errText(err)); }
    setBusy(false);
  };
  if (done) return <p className="label font-bold" data-testid={`${testid}-done`}>{done}</p>;
  return (
    <form onSubmit={submit} className="max-w-md" data-testid={testid}>
      <p className="label font-bold">Waitlist · Drop {drop.number}</p>
      <div className="mt-3 flex overflow-hidden rounded-[12px] border-[1.5px] border-ink bg-cloud">
        <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="your@email.com" aria-label={`Email for the Drop ${drop.number} waitlist`} className="min-w-0 flex-1 bg-transparent px-4 py-3 text-sm outline-none" data-testid={`${testid}-email`} />
        <button disabled={busy} className={`btn !h-auto !border-0 px-5 ${dark ? "btn-pink" : "btn-ink"}`} data-testid={`${testid}-submit`}>{busy ? "…" : "Join"} <ArrowRight size={15} /></button>
      </div>
      <label className="mt-3 flex items-center gap-2 text-[13px]">
        <input type="checkbox" checked={crew} onChange={(e) => setCrew(e.target.checked)} data-testid={`${testid}-newsletter`} /> Also join the Sus Crew newsletter
      </label>
    </form>
  );
};
